const routes = [
    {
        path: "/special-student/application/login",
        component: () => import("../student/pages/Index"),
    },
    {
        path: "/special-student/application/form",
        component: () => import("../student/pages/FormIndex"),
    },
    {
        path: "/special-student/applications",
        component: () => import("../admin/pages/Index"),
        meta:{
            isAuthenticated:true,
            // permissions:'',
        }

    }
];

export default routes;
